<template>
  <div class="rootDiv">
    <div>
      <img :style="{'text-align': 'center','background-color': 'white','max-width':imgWidth+'px'}"
           v-if="selectedAvatar === null"
           v-bind:src="user.avatarUrl" alt=""/>
      <img :style="{'text-align': 'center','background-color': 'white','max-width':imgWidth+'px'}"
           v-if="selectedAvatar !== null"
           v-bind:src="selectedAvatar" alt=""/>
    </div>
    <Field label="* 姓名" placeholder="请输入姓名" v-model="user.username"></Field>
    <Cell class="cell" title="照片" is-link v-on:click.native="openPicture">
    </Cell>
    <Field label="性别" placeholder="请选择性别" :readonly=true @focus.native.capture="SexPickerControl"
           v-model="user.sex"></Field>
    <Field label="* 出生日期" placeholder="请选择出生日期" :readonly=true @focus.native.capture="openDatePicker"
           v-model="user.date"></Field>
    <div style="width: 100%;margin-left: 0.5rem;margin-bottom: 1rem">
      <div class="line_top">
      </div>
      <div style="float: left;margin-bottom: 0.5rem;margin-top: 0.5rem;padding-left: 1.5rem">
        <div style="float:left;margin-top: 0.5rem">
          <span>日期类型</span>
        </div>
        <div style="float:left;margin-left: 1.2rem">
          <mt-switch v-model="user.dateType"></mt-switch>
        </div>
        <div style="float:left;margin-left: 1.2rem;margin-top: 0.4rem">
          <span v-if="user.dateType">公历</span>
          <span v-else>农历</span>
        </div>
      </div>
      <div class="line_bottom" style="display:none">
      </div>
    </div>
    <div style="clear:both;">
      <Field label="出生时间" placeholder="请选择出生时间" :readonly=true @focus.native.capture="openTimePicker"
             v-model="user.time"></Field>
    </div>
    <div style="width: 100%;margin-left: 0.5rem;margin-bottom: 1rem">
      <div class="line_top">
      </div>
      <div style="float: left;margin-bottom: 0.5rem;margin-top: 0.5rem;padding-left: 1.5rem">
        <div style="float:left;margin-top: 0.5rem">
          <span>是否去世</span>
        </div>
        <div style="float:left;margin-left: 1.2rem">
          <mt-switch v-model="user.isDead"></mt-switch>
        </div>
        <div style="float:left;margin-left: 1.2rem;margin-top: 0.4rem">
          <span v-if="user.isDead">是</span>
          <span v-else>否</span>
        </div>
      </div>
      <div class="line_bottom" style="display:none">
      </div>
    </div>
    <div style="clear:both;" v-if="user.isDead">
      <Field label="去世日期" placeholder="请选择出生日期" :readonly=true @focus.native.capture="openDeadDatePicker"
             v-model="user.deadDate"></Field>
    </div>
    <div style="clear: both" v-if="!user.isDead"></div>
    <Field label="国籍" v-model="user.nationality"></Field>
    <Field label="职业" v-model="user.occupation"></Field>
    <Field label="身高" type="number" v-model="user.height"></Field>
    <Field label="体重" type="number" v-model="user.weight"></Field>
    <Field label="学校" v-model="user.school"></Field>
    <Field label="公司" v-model="user.company"></Field>
    <Field label="爱好" v-model="user.hobby"></Field>
    <Field label="备注" v-model="user.remarks"></Field>
    <div class="line_bottom">
    </div>
    <Button size="large" class="addbutton" @click="ConfirmAdd">{{ isAdd ? '添  加' : '修  改' }}</Button>
    <DatetimePicker
        ref="date_picker"
        type="date"
        :startDate="startDate"
        :endDate="endDate"
        year-format="{value} 年"
        month-format="{value} 月"
        date-format="{value} 日"
        v-model="tempDate" @confirm="DateConfirm">
    </DatetimePicker>
    <DatetimePicker
        ref="dead_picker"
        type="date"
        :startDate="startDate"
        :endDate="endDate"
        year-format="{value} 年"
        month-format="{value} 月"
        date-format="{value} 日"
        v-model="tempDeadDate" @confirm="DeadDateConfirm">
    </DatetimePicker>
    <DatetimePicker
        ref="time_picker"
        type="time"
        hour-format="{value} 时"
        minute-format="{value} 分"
        v-model="tempTime" @confirm="TimeConfirm">
    </DatetimePicker>
    <Popup class="sexpopup"
           v-model="popupVisible"
           position="bottom">
      <div>
        <div class="buttondiv1"><span @click="SexPickerControl">取消</span></div>
        <div class="buttondiv2"><span @click="SexPickerControl">确定</span></div>
      </div>
      <div class="line"></div>
      <div class="pickerdiv">
        <Picker :slots="slots" @change="onValuesChange"></Picker>
      </div>
    </Popup>
    <input style="float: left;  display: none;" type="file" id='uploadFile' accept="image/*"
           v-on:change="readLocalFile()">
  </div>
</template>

<script>
import {Button, DatetimePicker, Field, Picker, Popup, Switch, Cell} from 'mint-ui';
//import 'mint-ui/lib/style.css'
import Vue from 'vue'
import {formatdate} from "@/js/DateUtils";

Vue.component(Switch.name, Switch);

export default {
  name: "AddStarBirthday",
  components: {
    DatetimePicker,
    Field,
    Button,
    Picker,
    Popup,
    Cell
  },
  mounted() {
    if (this.$route.query.birth !== undefined && this.$route.query.birth !== null) {
      this.isAdd = false
      this.user.id = this.$route.query.birth['birthdayInfoModel']['iD']
      this.user.username = this.$route.query.birth['birthdayInfoModel']['name']
      this.user.sex = this.$route.query.birth['birthdayInfoModel']['sex']
      this.user.date = this.$route.query.birth['birthdayInfoModel']['dateOfBirthDay']
      this.user.time = this.$route.query.birth['birthdayInfoModel']['timeOfBirth']
      this.user.isInGroup = this.$route.query.birth['birthdayInfoModel']['isInGroup']
      let dateType = this.$route.query.birth['birthdayInfoModel']['dateType'] === 'Solar' ? 1 : 0
      this.user.dateType = Boolean(Number(dateType))
      this.user.remarks = this.$route.query.birth['birthdayInfoModel']['remarks']
      this.user.isDead = this.$route.query.birth['birthdayInfoModel']['deadDate'] !== null
      this.user.deadDate = this.formatDateString(this.$route.query.birth['birthdayInfoModel']['deadDate'])

      this.user.nationality = this.$route.query.birth['starInfoModel']['gJ']
      this.user.occupation = this.$route.query.birth['starInfoModel']['zY']
      this.user.height = this.$route.query.birth['starInfoModel']['sG']
      this.user.weight = this.$route.query.birth['starInfoModel']['tZ']
      this.user.school = this.$route.query.birth['starInfoModel']['xX']
      this.user.company = this.$route.query.birth['starInfoModel']['gS']
      this.user.hobby = this.$route.query.birth['starInfoModel']['aH']
      this.user.avatarUrl = this.$route.query.birth['starInfoModel']['zP']
    }
  },
  data() {
    return {
      imgWidth: document.documentElement.clientWidth - 6,
      selectedAvatar: null,
      isAdd: true,
      user: {
        id: null,
        avatarUrl: null,
        username: null,
        sex: null,
        date: null,
        time: null,
        dateType: true,
        isDead: false,
        deadDate: null,
        remarks: null,
        nationality: null,
        occupation: null,
        height: null,
        weight: null,
        school: null,
        company: null,
        hobby: null,
      },
      birthdayModel: {
        CSRQNM: null,
        XM: null,
        XBNM: null,
        CSN: null,
        CSY: null,
        CSR: null,
        CSS: null,
        CSF: null,
        SRLXNM: null,
        BZ: null,
        QSSJ: null,
        TJSJ: null,
        GJ: null,
        ZY: null,
        SG: null,
        TZ: null,
        XX: null,
        GS: null,
        AH: null,
        ZP: null,
        YZP: null,
      },
      startDate: new Date("1901-01-01"),
      endDate: new Date(),
      tempDate: new Date("1990-01-01"),
      tempTime: '00:00',
      tempDeadDate: new Date(),
      slots: [
        {
          flex: 1,
          values: ['男', '女'],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      popupVisible: false,
      updateUrl: '/api/star/updateBirthday',
      insertUrl: '/api/star/insertBirthday',
      token: localStorage.getItem('token'),
    }
  },
  methods: {
    openPicture() {
      document.getElementById("uploadFile").click();
    },
    //点击选中图片
    readLocalFile: function () {
      const localFile = document.getElementById("uploadFile").files[0];
      const reader = new FileReader();
      const current = this;
      reader.onload = function (event) {
        current.selectedAvatar = event.target.result;//获取图片base64代码
      }
      reader.readAsDataURL(localFile, "UTF-8");
    },
    DeadDateConfirm() {
      this.user.deadDate = this.formatDate(this.tempDeadDate)
    },
    onValuesChange(picker, values) {
      this.user.sex = values[0]
    },
    SexPickerControl() {
      this.popupVisible = !this.popupVisible
    },
    openDatePicker() {
      if (this.user.date != null)
        this.tempDate = this.user.date
      this.$refs.date_picker.open();
    },
    formatDateString(time) {
      const date = new Date(time);
      return formatdate(date, 'yyyy-MM-dd');  // 此处可根据自己的需要自定义想要的日期格式
    },
    openTimePicker() {
      if (this.user.time != null)
        this.tempTime = this.user.time
      this.$refs.time_picker.open();
    },
    openDeadDatePicker() {
      if (this.user.deadDate != null)
        this.tempDeadDate = this.user.deadDate
      this.$refs.dead_picker.open();
    },
    ConfirmUpdate() {
      let that = this
      that.birthdayModel.CSRQNM = that.user.id
      that.birthdayModel.XM = that.user.username
      that.birthdayModel.XBNM = that.user.sex
      that.birthdayModel.CSN = that.user.date.split('-')[0]
      that.birthdayModel.CSY = that.user.date.split('-')[1]
      that.birthdayModel.CSR = that.user.date.split('-')[2]
      if (that.user.time != null) {
        that.birthdayModel.CSS = that.user.time.split(':')[0]
        that.birthdayModel.CSF = that.user.time.split(':')[1]
      }
      that.birthdayModel.BZ = that.user.remarks
      that.birthdayModel.SRLXNM = that.user.dateType
      if (that.user.isDead) {
        that.birthdayModel.QSSJ = that.user.deadDate
      } else {
        that.birthdayModel.QSSJ = null
      }
      that.birthdayModel.GJ = that.user.nationality
      that.birthdayModel.ZY = that.user.occupation
      that.birthdayModel.SG = that.user.height
      that.birthdayModel.TZ = that.user.weight
      that.birthdayModel.XX = that.user.school
      that.birthdayModel.GS = that.user.company
      that.birthdayModel.AH = that.user.hobby
      if (that.selectedAvatar !== null)
        that.birthdayModel.ZP = this.user.avatarUrl

      let params = {json: that.birthdayModel}
      if (that.selectedAvatar) {
        params = {json: that.birthdayModel, zp: that.selectedAvatar}
      }

      that.$ajax({
        method: 'POST',
        url: that.updateUrl,
        data: params,
        headers: {token: that.token}
      }).then((response) => {
        let result = response.data['result']
        if (!result) {
          that.$messagebox.alert(response.data.message).then(action => {
            if (action === 'confirm') {
              this.$router.go(-1)
            }
          });
        } else
          this.$router.go(-1)
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      });
    },
    ConfirmAdd() {
      if (!this.isAdd) {
        this.ConfirmUpdate()
        return;
      }
      let that = this;
      if (that.user.username === null || that.user.username === '') {
        this.$toast({
          message: "请填写姓名",
          position: 'middle',
        });

        return
      }
      if (that.user.date === null || that.user.date === '') {
        this.$toast({
          message: "请选择出生日期",
          position: 'middle',
        });
        return
      }
      that.birthdayModel.CSRQNM = that.user.id
      that.birthdayModel.XM = that.user.username
      that.birthdayModel.XBNM = that.user.sex
      that.birthdayModel.CSN = that.user.date.split('-')[0]
      that.birthdayModel.CSY = that.user.date.split('-')[1]
      that.birthdayModel.CSR = that.user.date.split('-')[2]
      if (that.user.time != null) {
        that.birthdayModel.CSS = that.user.time.split(':')[0]
        that.birthdayModel.CSF = that.user.time.split(':')[1]
      }
      that.birthdayModel.BZ = that.user.remarks
      that.birthdayModel.SRLXNM = that.user.dateType
      if (that.user.isDead) {
        that.birthdayModel.QSSJ = that.user.deadDate
      }
      that.birthdayModel.GJ = that.user.nationality
      that.birthdayModel.ZY = that.user.occupation
      that.birthdayModel.SG = that.user.height
      that.birthdayModel.TZ = that.user.weight
      that.birthdayModel.XX = that.user.school
      that.birthdayModel.GS = that.user.company
      that.birthdayModel.AH = that.user.hobby
      that.birthdayModel.ZP = this.user.avatarUrl

      let params = {json: that.birthdayModel}
      if (that.selectedAvatar) {
        params = {json: that.birthdayModel, zp: that.selectedAvatar}
      }
      that.$ajax({
        method: 'POST',
        url: that.insertUrl,
        data: params,
        headers: {token: that.token}
      }).then((response) => {
        let result = response.data['result']
        if (!result) {
          that.$messagebox.alert(response.data.message).then(action => {
            if (action === 'confirm') {
              this.$router.go(-1)
            }
          });
        } else
          this.$router.go(-1)
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      });
    },
    //更改时间格式
    formatTen(num) {
      return num > 9 ? (num + "") : ("0" + num);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return year + '-' + this.formatTen(month) + '-' + this.formatTen(day);
    },
    DateConfirm() {
      this.user.date = this.formatDate(this.tempDate)
    },
    TimeConfirm() {
      this.user.time = this.tempTime
    }
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin-top: -0.5rem;
  margin-left: -0.3rem;
  width: 100%;

  .addbutton {
    background: lightseagreen;
  }
}

.cell {
  text-align: left;
  margin-left: 2.3rem;
}

.sexpopup {
  width: 100%;
  padding-top: 1rem;

  span {
    color: #2986de;
    font-size: 1rem;
  }
}

.buttondiv1 {
  width: 50%;
  float: left;
}

.buttondiv2 {
  width: 50%;
  float: left;
}

.pickerdiv {
  clear: both;
}

.line {
  width: 100%;
  border-top: solid gray 0.5px;
  margin-top: 1.8rem;
}

.line_top {
  width: 100%;
  border-top: solid darkgray 0.5px;
  margin-top: 0;
}

.line_bottom {
  width: 100%;
  border-top: solid darkgray 0.5px;
  margin-top: 3rem;
}
</style>
